import { GET_COLLECTION } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_COLLECTION.LOAD:
      return {
        ...state,
        loading: true
      };
    case GET_COLLECTION.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case GET_COLLECTION.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
